import { DocumentRequestPdfControlContext } from "features/documents/pages/documentRequest/context/PDFSignatureControlContext";
import { useContext } from "react";

export const usePDFSignatureControl = () => {
  const pdfSignatureControlContext = useContext(
    DocumentRequestPdfControlContext
  );
  return pdfSignatureControlContext;
};
